import { Box, Grid2, InputLabel, Typography } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useEffect, useState } from "react";
import { useViewAdminByIdMutation } from "../../redux/Admin/AddAdmin.api";
import './adminCoordinators.css';
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import MUIButton from "../../reusable_components/components/MUIButton";



const ViewAdminCoordinators = () => {

    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()

    const [ViewAdminById, { data: getAdminById }] = useViewAdminByIdMutation()


    const [value, setValue] = useState('1')
    const { type } = location.state || ""
    const handleTabChange = (e, newvalue) => {
        setValue(newvalue)
    }

    const editId = +params?.id

    useEffect(() => {
        if (editId) {
            const payload = {
                coordinatorId: editId
            }
            ViewAdminById(payload);
        }

    }, [editId])

    const handleClientEdit = () => {
        navigate(`/edit-admin/${editId}`)
    }


    return (
        <Box className="container">

            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px' }} onClick={() => navigate('/admin')}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <Box>
                    <Typography className="title" sx={{ marginTop: '20px' }}>{type ? "Admin" : "Co-ordinator"}</Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                    {/* <MUICancelButton title='Share' startIcon={<ShareOutlinedIcon sx={{ fontSize: '15px !important' }} />} /> */}
                    <MUIButton title='Edit' className="edit-button" onClick={handleClientEdit} />
                </Box>
            </Box>


            {/* Tab main grid */}
            <Grid2>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleTabChange} >
                            <Tab label="Overview" value="1"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "1" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }} >
                            </Tab>
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{ padding: 1.5 }}>
                        {/* box inside the tab  */}
                        <Typography sx={{ fontWeight: 700, fontSize: '18px', }}>Basic Information</Typography>
                        {
                            getAdminById?.response?.data?.map((item) => (
                                <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', marginTop: '10px', gap: '20px' }}>
                                    {/* left grid */}

                                    <Grid2 rowGap={2} sx={{ width: '100%', display: 'flex', flexDirection: 'column' }} >
                                        <Box>
                                            <InputLabel>Name</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.firstName || '-'} {item?.lastName || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>User Type</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.userType === "1" ? ("Admin") : ("Coordinator") || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Email</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.email || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>City</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.city || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Address</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.address || '-'}</Typography>
                                        </Box>

                                    </Grid2>

                                    <Grid2 rowGap={2} sx={{ width: '100%', display: 'flex', flexDirection: 'column' }} >
                                        <Box>
                                            <InputLabel>Mobile</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.mobile || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>State</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.state || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Pincode</InputLabel>
                                            <Typography className="viewAdminCoordinators">{item?.pincode || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Status</InputLabel>
                                            <Typography sx={{fontWeight:'none',fontSize: '11px !important'}} className={`status-bage ${item?.status === "1" ? "status-bage-active" : "status-bage-inactive"}`}>
                                                {item?.status === "1" ? "Active" : "Inactive"}
                                            </Typography>
                                        </Box>

                                    </Grid2>
                                </Box>

                            ))
                        }
                    </TabPanel>
                </TabContext>
            </Grid2>
        </Box>
    )
}
export default ViewAdminCoordinators